var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"speaker-intro"},[(_vm.imgSrc)?_c('img',{staticClass:"avatar",attrs:{"src":_vm.imgSrc,"alt":("photo of speaker " + (_vm.speaker.NAME_EN || _vm.speaker.NAME))}}):_c('img',{staticClass:"avatar",attrs:{"alt":"placeholder image","src":require("@/assets/SpeakerPage/default_avatar.png")}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-65ab2b46","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/SpeakerAvatar.vue
// module id = 504
// module chunks = 1